package com.dotdrives.web.pages.forms

import com.dotdrives.controller.FormBuilderController
import com.dotdrives.controller.FormBuilderUiState
import com.dotdrives.model.*
import com.dotdrives.web.pages.giving.givingContactFields
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface FormTabProps : Props {
    var state: FormBuilderUiState
    var controller: FormBuilderController
    var canWrite: Boolean
}
external interface FormDesignTabProps : FormTabProps {
    var openSection: String?
    var onOpenSection: (String?) -> Unit
}

val FormDesignTab = FC<FormDesignTabProps> { props ->
    val state = props.state
    val fields = givingContactFields(FormConfig(fields = state.draftFields))
    val target = state.targets.firstOrNull { it.id == state.draftTargetId }?.name
        ?: state.form?.takeIf { it.targetId == state.draftTargetId }?.targetName ?: "No target"
    val options = listOfNotNull(
        "Monthly".takeIf { state.draftToggles.monthlyGiving }, "Quarterly".takeIf { state.draftToggles.quarterlyGiving },
        "Other".takeIf { state.draftToggles.customAmount },
        "Cover fees".takeIf { state.draftToggles.coverFees }, "Anonymous".takeIf { state.draftToggles.anonymousGifts },
    )
    val sections = listOf(
        Triple("story", "Story & brand", "${state.draftHeadline.ifBlank { "No headline" }} · ${state.draftStory.length}-character story"),
        Triple("amounts", "Gift amounts & options", (state.draftAmounts.map { "$${amountInputValue(it.amount)}" } + options).joinToString(" · ").ifBlank { "No suggested amounts" }),
        Triple("fields", "Donor details", "${fields.size} fields · ${fields.count { it.required }} required"),
        Triple("match", "Employer matching", if (state.draftEmployerMatches.isEmpty()) "No employer programs listed" else "${state.draftEmployerMatches.size} employer programs"),
        Triple("target", "Where gifts go", target + state.draftGoalAmount.takeIf(String::isNotBlank)?.let { " · $$it goal" }.orEmpty()),
    )
    sections.forEachIndexed { index, (id, title, summary) ->
        val open = props.openSection == id
        div {
            key = id.unsafeCast<react.Key>()
            className = ClassName("forms-v2-section" + if (open) " forms-v2-section-open" else "")
            button {
                type = ButtonType.buttonType; className = ClassName("forms-v2-section-heading")
                ariaExpanded = open; ariaControls = "form-section-$id".unsafeCast<web.dom.ElementId>()
                onClick = { props.onOpenSection(if (open) null else id) }
                span { className = ClassName("forms-v2-section-number"); +(index + 1).toString() }
                span {
                    className = ClassName("forms-v2-section-label")
                    span { className = ClassName("forms-v2-section-title"); +title }
                    span { className = ClassName("forms-v2-section-summary"); +summary }
                }
                span { className = ClassName("forms-v2-chevron"); ariaHidden = true; +if (open) "▴" else "▾" }
            }
            div {
                hidden = (!open).unsafeCast<web.html.Hidden>()
                this.id = "form-section-$id".unsafeCast<web.dom.ElementId>(); className = ClassName("forms-v2-section-body")
                when (id) {
                    "story" -> PublicFormConfiguration { this.state = state; controller = props.controller; canWrite = props.canWrite }
                    "amounts" -> FormAmountEditor { this.state = state; controller = props.controller; canWrite = props.canWrite }
                    "fields" -> FormDonorFieldsEditor { this.state = state; controller = props.controller; canWrite = props.canWrite }
                    "match" -> FormEmployerEditor { this.state = state; controller = props.controller; canWrite = props.canWrite }
                    "target" -> FormDestinationEditor { this.state = state; controller = props.controller; canWrite = props.canWrite }
                }
            }
        }
    }
}
